import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CreateCommandePage } from "@/features/ventes/components/commandes/CreateCommandePage";

export const Route = createFileRoute("/_app/ventes/commandes/create")({
  loader: requirePermission(PERMISSIONS.VENTES.COMMANDES.CREATE),
  staticData: {
    title: "Nouvelle commande",
    showInBreadcrumb: true,
  },
  component: CreateCommandePage,
});
